import { render, staticRenderFns } from "./ReviewEdit.vue?vue&type=template&id=28a9326e&scoped=true&"
import script from "./ReviewEdit.vue?vue&type=script&lang=js&"
export * from "./ReviewEdit.vue?vue&type=script&lang=js&"
import style0 from "./ReviewEdit.vue?vue&type=style&index=0&id=28a9326e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a9326e",
  null
  
)

export default component.exports